export default {"src":"/_next/static/media/location-cross.2ebfda97.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};